<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar :background-color="sidebarBackground" :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')">
      <template slot="links">

        <!-- SUPERADMIN -->
        <sidebar-item v-if="isSuperAdmin" :link="{
          name: $t('nav.dashboard'),
          icon: 'tim-icons icon-chart-pie-36',
          path: '/admin/dashboard'
        }"></sidebar-item>

        <sidebar-item v-if="isSuperAdmin" :link="{
          name: $t('nav.clients'),
          icon: 'tim-icons icon-bank',
          path: '/admin/clients'
        }"></sidebar-item>

        <sidebar-item v-if="isSuperAdmin" :link="{
          name: $t('nav.payments'),
          icon: 'tim-icons icon-coins',
          path: '/admin/payments'
        }"></sidebar-item>

        <!-- ADMIN + USER -->
        <sidebar-item v-if="!isSuperAdmin" :link="{
          name: $t('nav.pos'),
          icon: 'tim-icons icon-cart',
          path: '/fiscal/pos'
        }"></sidebar-item>

        <sidebar-item v-if="!isSuperAdmin" :link="{
          name: $t('nav.locations'),
          icon: 'tim-icons icon-square-pin',
          path: '/fiscal/locations'
        }"></sidebar-item>

        <sidebar-item v-if="!isSuperAdmin" :link="{
          name: $t('nav.esirs'),
          icon: 'tim-icons icon-tv-2',
          path: '/fiscal/esirs'
        }"></sidebar-item>

        <sidebar-item v-if="isAdmin && !isSuperAdmin" :link="{
          name: $t('nav.users'),
          icon: 'tim-icons icon-single-02',
          path: '/fiscal/users'
        }"></sidebar-item>

        <sidebar-item v-if="!isSuperAdmin" :link="{
          name: $t('nav.invoices'),
          icon: 'tim-icons icon-paper',
          path: '/fiscal/invoices'
        }"></sidebar-item>

        <sidebar-item v-if="!isSuperAdmin" :link="{
          name: $t('nav.reports'),
          icon: 'tim-icons icon-chart-bar-32',
          path: '/fiscal/reports'
        }"></sidebar-item>

        <sidebar-item v-if="isAdmin && !isSuperAdmin" :link="{
          name: $t('nav.apiTokens'),
          icon: 'tim-icons icon-key-25',
          path: '/fiscal/api-tokens'
        }"></sidebar-item>

        <!-- Logout -->
        <sidebar-item :link="{
          name: $t('nav.logout'),
          icon: 'tim-icons icon-button-power'
        }" @click.native="logout"></sidebar-item>

      </template>
    </side-bar>
    <sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div :class="{ content: !$route.meta.hideContent }" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from './SidebarSharePlugin';
import axios from '@/util/axiosinstance'

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
    SidebarShare
  },
  computed: {
    fiscalUser() {
        try {
            return JSON.parse(localStorage.getItem('fiscal_user') || '{}')
        } catch (e) {
            return {}
        }
    },
    isAdmin() {
        return this.fiscalUser.role === 'ADMIN' || this.fiscalUser.role === 'SUPERADMIN'
    },
    isSuperAdmin() {
        return this.fiscalUser.role === 'SUPERADMIN'
    },
    userName() {
        return this.fiscalUser.name || this.fiscalUser.clientName || 'Korisnik'
    },
    clientName() {
        return this.fiscalUser.clientName || ''
    }
  },
  data() {
    return {
      sidebarBackground: 'vue'
    };
  },
  methods: {
    logout() {
      localStorage.removeItem('fiscal_api_key')
      localStorage.removeItem('fiscal_user')
      this.$router.push('/login')
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');
        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  mounted() {
    this.initScrollbar();
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}

.wrapper {
  background: linear-gradient(135deg, #f0f4f8 0%, #d9e7f0 100%);
  min-height: 100vh;
}

.sidebar {
  background: linear-gradient(180deg, #2c5282 0%, #2b6cb0 100%) !important;
}

.sidebar .sidebar-wrapper {
  background: transparent !important;
}

.sidebar .nav li>a {
  color: rgba(255, 255, 255, 0.8);
}

.sidebar .nav li>a:hover,
.sidebar .nav li.active>a {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

.sidebar .logo {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.sidebar .logo .simple-text {
  color: #ffffff;
}
</style>